module.exports = __webpack_public_path__ + "static/media/instagram.e9acc70f.svg";